const defaultCustomerAgentRecommendedQuestions = {
  questions: [],
  status: 'READY'
};
const CustomerAgentRecommendedQuestions = customerAgentRecommendedQuestions => Object.assign({}, defaultCustomerAgentRecommendedQuestions, customerAgentRecommendedQuestions);
export default CustomerAgentRecommendedQuestions;